<template>
  <div id="login">
    <div class="box hide-scrollbars">
      <div class="info" v-if="event_loaded">
        <img
          class="logo"
          :class="['s' + event.type_id]"
          :src="event.logo_login"
        />
      </div>
      <div class="info" v-else>
        <img class="logo main" :src="app_url + 'img/logo_new_black.png'" />
        <div class="description">{{ $t("login.description") }}</div>
      </div>

      <div class="language">
        <div @click="loadLang('ca')" class="lang">CA</div>
        <div @click="loadLang('es')" class="lang">ES</div>
        <div @click="loadLang('en')" class="lang">EN</div>
      </div>

      <div class="form" v-if="!show_remember">
        <!-- <v-container class="event-list">
            <v-layout row wrap class="section-container" id="basic">
                <v-flex xs2 class="item" v-for="(event,index) in events" :key="index">
                    <img class="logo" :src="event.logo"/>
                </v-flex>
                <v-flex xs2 class="item" v-for="(event,index) in events" :key="index">
                    <div class="empty"></div>
                </v-flex>
            </v-layout>
        </v-container> -->
        <div class="message error" v-if="error_message">
          {{ $t("errors.login") }}
        </div>
        <v-select
          v-if="!event_loaded"
          :placeholder="$t('login.event_selector')"
          v-model="event_selected"
          :items="events"
          hide-details
          outline
        />
        <input
          type="text"
          name="username"
          v-model="input.username"
          :placeholder="$t('login.email')"
          v-on:focus="onfocus = true"
          v-on:focusout="onfocus = false"
          v-on:keyup.enter="login()"
          autocomplete="new-text"
        />
        <input
          type="password"
          name="password"
          v-model="input.password"
          :placeholder="$t('login.password')"
          v-on:focus="onfocus = true"
          v-on:focusout="onfocus = false"
          v-on:keyup.enter="login()"
          autocomplete="new-text"
        />
        <button
          type="button"
          :style="{ backgroundColor: true ? event.color : '' }"
          v-on:click="login()"
        >
          {{ $t("login.login") }}
        </button>
        <button
          type="button"
          class="secondary"
          @click="show_remember = !show_remember"
        >
          {{ $t("login.rememberme") }}
        </button>
        <!-- <Language></Language> -->
        <!-- <router-link to="/remember" class="remember">{{$t( 'login.rememberme' )}}</router-link> -->
      </div>

      <div class="form" v-else>
        <div v-if="remember_user_ok" class="success">
          {{ $t("login.email_send") }}
        </div>
        <div v-if="error_remember_user" class="message error">
          {{ $t("errors.login") }}
        </div>
        <div></div>
        <input
          type="text"
          name="username"
          v-model="remember_user"
          :placeholder="$t('login.email')"
          v-on:keyup.enter="rememberPassword()"
          autocomplete="new-text"
        />
        <button
          type="button"
          :style="{ backgroundColor: event_loaded ? event.color : '' }"
          @click="rememberPassword()"
        >
          {{ $t("update") }}
        </button>
        <button
          type="button"
          class="secondary"
          @click="show_remember = !show_remember"
        >
          {{ $t("cancel") }}
        </button>
      </div>
    </div>

    <div @click="goIntowin" class="tech-partner" :class="{ onfocus }"></div>
  </div>
</template>

<script>
/* global isEmpty, sha256 */
import { Api } from '@/core/api.js'
import i18n from '@/i18n'

const api = new Api()

export default {
  name: 'Login',
  data () {
    return {
      input: {
        username: '',
        password: ''
      },
      app_url: process.env.VUE_APP_APP_URL,
      error_message: false,
      campus: false,
      show_remember: false,
      remember_user: '',
      error_remember_user: false,
      remember_user_ok: false,
      lang: '',
      event_load: false,
      onfocus: false
    }
  },

  computed: {
    event () {
      const oEvent = { ...this.$store.getters.getCurrentEvent() }
      if (oEvent && Object.keys(oEvent).length > 0) {
        oEvent.logo_login =
          oEvent.type_id !== 13
            ? oEvent.logo.replace(/(\.\w+)$/, '_logo$1')
            : oEvent.logo
      }
      return oEvent
    },

    event_loaded: {
      get () {
        return this.event_load
      },
      set (val) {
        this.event_load = val
      }
    },

    event_selected: {
      get () {
        if (this.$store.getters.getCurrentEvent()) {
          return this.$store.getters.getCurrentEvent().id
        } else {
          return false
        }
      },
      set (val) {
        const event = this.$store.getters.getActiveEvents()[val]
        if (event) {
          this.$store.commit('setCurrentEvent', event)
        }
      }
    },

    events () {
      const aEvents = this.$store.getters.getActiveEvents()
      return Object.values(aEvents)
        .map(event => {
          if (event.type_id === 12) {
            event.name = 'MIC CAMP BARCELONA'
          } else if (event.type_id === 4) {
            event.name = 'MIC CAMP ANDORRA'
          }
          return {
            value: event.id,
            text: `${event.name}'${event.edition.substring(2)}`,
            logo: event.logo
          }
        })
        .sort((a, b) => (a.text < b.text ? -1 : 1))
    }
  },

  created () {
    this.onChangeRoute()
  },

  watch: {
    $route: 'onChangeRoute',

    event: {
      handler (oEvent) {
        this.event_loaded = !!(oEvent && oEvent.id)
      },
      immediate: true
    }
  },

  methods: {
    goIntowin () {
      window.open('http://www.intowin.io', '_blank')
    },

    onChangeRoute () {
      const lang = this.$route.params.lang || 'ca'
      i18n.loadLanguageAsync(lang).then(() => {
        if (this.$route.params.event) {
          this.event_loaded = true
        }
      })
    },

    login () {
      const username = this.input.username.trim()
      const password = this.input.password.trim()

      // Basic validation
      if (!username || !password) {
        this.error_message = true
        return
      }

      const payload = {
        username,
        password: sha256(password),
        event: this.event_selected,
        route: '/login'
      }

      api.login(payload).then(response => {
        if (!response.status) {
          this.error_message = true
          return
        }

        this.error_message = false
        const event = this.$store.getters.getCurrentEvent()

        // Handle club-specific login
        if (response.data.sel_club) {
          this.$store.commit('user/setAuthenticateSelClub', response.data)
          return this.redirectTo('sel_club', event)
        }

        // General login
        this.$store.commit('user/setAuthenticate', response.data)
        localStorage.setItem('token', response.data.token)

        this.$store.dispatch('loadTablesRelationship').then(() => {
          if (this.campus) {
            this.$store.commit('setCampus', true)
          }
          this.redirectTo('home', event)
        })
      })
    },

    redirectTo (routeName, event) {
      this.$router.push({
        name: routeName,
        params: {
          event: this.$root.formatEventUrl(event.name, event.edition)
        }
      })
    },

    rememberPassword () {
      this.remember_user_ok = false
      this.error_remember_user = false

      if (isEmpty(this.remember_user)) {
        return
      }

      api
        .post('remember', {
          username: this.remember_user,
          lang: this.lang,
          event: this.event_selected
        })
        .then(response => {
          this.remember_user_ok = response.status
          this.error_remember_user = !response.status
        })
    },

    loadLang (lang) {
      const event = this.$store.getters.getCurrentEvent()
      const routeName = event ? 'event_login_with_lang' : 'login_with_lang'
      const params = event
        ? {
          event: this.$root.formatEventUrl(event.name, event.edition),
          lang
        }
        : { lang }
      this.$router.push({ name: routeName, params })
    }
  }
}
</script>

<style lang="scss" scoped>
#container {
  padding: 0 !important;
}

.language {
  position: absolute;
  top: 10px;
  right: 10px;

  .lang {
    padding: 0 10px;
    font-weight: bold;
    font-size: 20px;
    float: left;
    // font-family: AvantGarde-Bold;
    cursor: pointer;

    &:not(:first-child) {
      border-left: 1px solid #000;
    }
  }
}

#login {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 25px;
  background: linear-gradient(0deg, rgb(245, 245, 245), #fff);
  color: $secondary-color;
  overflow: auto;

  .box {
    max-width: 275px;
    width: 100%;
    height: auto;
    max-height: calc(100% - 40px);
    margin: 0 auto;
    overflow: auto;
    text-align: center;

    .message.error {
      background-color: #f73f2061;
      margin: 10px 0;
      border: 2px solid #e61515;
      border-radius: 5px;
      padding: 10px;
      color: #fff;
      font-weight: bold;
    }

    .info {
      text-align: center;

      .logo {
        display: inline-block;
        height: 150px;
        padding: 15px;

        &.s13 {
          height: inherit !important;
        }

        &.main {
          height: 100px;
        }
      }

      .description {
        width: 100%;
        display: block;
        color: $main-color;
        font-size: 16px;
        text-align: center;
      }
    }
    .form {
      margin-top: 50px;
    }

    input {
      width: 100%;
      padding: 15px;
      margin-bottom: 5px;
      border: 1px solid #444;
      outline: none;
      font-size: 11pt;
      border-radius: 3px;
      color: $main-color;
      display: block;

      &::placeholder {
        color: $main-color;
      }
    }

    button {
      width: calc(100%);
      padding: 12px;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 12pt;
      border-radius: 3px;
      text-transform: uppercase;
      transition: all 0.5s;
      background-color: #000;
      color: $secondary-color;
      margin-top: 12px;
      font-weight: bold;

      &.secondary {
        background: none;
        text-transform: initial;
        color: #999;
        font-weight: lighter;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    button + .mlanguage {
      width: calc(100% - 50px);
    }

    button + .mlanguage,
    .mlanguage {
      display: inline-block;
      margin-top: 12px;
      height: 40px;
    }
    .mlanguage {
      float: none;
    }

    .remember {
      font-size: 10pt;
      margin-top: 20px;
      color: $secondary-color;
      cursor: pointer;
      display: block;
      text-decoration: none;
      text-align: center;
      color: #999;
      text-decoration: underline;

      &:hover {
        text-decoration: underline;
      }
    }

    .success {
      border: 2px solid #087908;
      border-radius: 5px;
      background-color: #a0f8b6;
      color: #000;
      padding: 10px;
      font-size: 16px;
      text-align: center;
    }
  }

  .tech-partner {
    @include display-flex();
    @include align-items(center);
    @include justify-content(center);
    position: fixed;
    // position: fixed;
    bottom: 10px;
    left: 0;
    width: 100%;
    text-align: center;
    height: 50px;
    @include background(
      $image: img("intowin_partner_v2.png"),
      $size: 250px,
      $position: center
    );
    cursor: pointer;
  }
}

@include media("<=desktop") {
  #login {
    overflow: hidden;
    margin-top: 50px;

    .box .info .logo {
      height: 100px;
      padding: 6px;
      width: auto;
    }
    .box .form {
      margin-top: 24px;
    }

    .tech-partner.onfocus {
      display: none;
    }
  }
}
</style>
<style lang="scss">
#login {
  .v-input {
    margin-bottom: 5px;
    .v-input__slot,
    .v-input__slot:hover {
      border: 1px solid #000;

      .v-select__selections {
        padding-top: 0;
        input::-webkit-input-placeholder {
          color: #000;
        }
      }
    }
  }
}
</style>
